export const OPEN_INTERCOM_CHAT = 'OPEN_INTERCOM_CHAT';
export const CLOSE_INTERCOM_CHAT = 'CLOSE_INTERCOM_CHAT';
